import Column from '@amzn/meridian/column';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import { escapeRegExp } from 'lodash';
import React, { FC, useMemo, useState } from 'react';
import { TranslatedString } from '../../blocks';
import { useTranslation } from '../../blocks/localization';

interface SearchableSelectFilterProps {
    value: string[];
    onChange: (values: string[]) => void;
    options: string[];
    label: TranslatedString;
    placeholder: TranslatedString;
    dataTestId?: string;
    formatOptionLabel?: (option: string) => string;
}

const SearchableSelectFilter: FC<SearchableSelectFilterProps> = ({
    value,
    onChange,
    options,
    label,
    placeholder,
    dataTestId,
    formatOptionLabel,
}) => {
    const [searchQuery, setSearchQuery] = useState('');
    const { t } = useTranslation(['purchaseOrderListPage']);

    const matchedOptions = useMemo(() => {
        const getLabel = (opt: string) => (formatOptionLabel ? formatOptionLabel(opt) : opt);
        if (!searchQuery) return options;
        const regex = new RegExp(escapeRegExp(searchQuery), 'i');
        return options.filter((opt) => regex.test(getLabel(opt)));
    }, [searchQuery, options, formatOptionLabel]);

    return (
        <Select
            value={value}
            onChange={onChange}
            searchQuery={searchQuery}
            onSearch={setSearchQuery}
            label={label}
            placeholder={placeholder}
            data-testid={dataTestId}
        >
            {matchedOptions.map((option) => (
                <SelectOption
                    label={formatOptionLabel ? formatOptionLabel(option) : option}
                    value={option}
                    key={option}
                />
            ))}
            {!matchedOptions.length && (
                <Column alignmentVertical={'center'}>
                    <Text alignment={'center'}>{t('noResults-text')}</Text>
                </Column>
            )}
        </Select>
    );
};

export default SearchableSelectFilter;
